import Login from "@/views/auth/Login";
import { createFileRoute } from "@tanstack/react-router";

type LoginSearch = {
  reset?: "success";
};

export const Route = createFileRoute("/login")({
  validateSearch: (search: Record<string, unknown>): LoginSearch => ({
    reset: search.reset === "success" ? "success" : undefined,
  }),
  component: LoginPage,
});

function LoginPage() {
  return (
    <Login error={null} />
  )
}
